import React from "react";
import { Col, Space } from "antd";

import EventUserList from "../../components/EventUserList";
import EventPrizeList from "../../components/EventPrizeList";

function CampnicFair() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">2024 캠프닉페어</h3>
                <EventUserList eventId={4} />
                <EventPrizeList eventId={4} />
            </Space>
        </div>
    );
}

export default CampnicFair;
